import { StandardContentDropdownList } from "./StandardContentDropdownList";

export default StandardContentDropdownList;
